import React from "react";
import { Chip, Typography } from "@mui/material/";
import styles from "./styles";
import { strings } from "../../i18n";

const AssetStatus = ({ status }) => {
    let classes = styles.greenChip;
    if (status.id === 2 || status.id == 3) {
        classes = styles.blueChip;
    }
    if (status.id === 4 || status.id == 5) {
        classes = styles.greenChip;
    }

    return status ? (
        <Chip variant="caption" sx={classes} label={status.name} />
    ) : (
        ""
    );
};

export default AssetStatus;
